import { isDefined, isNonEmpty } from '@sgme/fp';
import { connect } from 'react-redux';
import { refreshScheduleThunk } from 'state/formData/formData.thunks';
import { isPendingEnrichment } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export interface StateProps {
  isDisabled: boolean;
}

export interface RefreshSchedulePropsOwnProps {
  tabId: string;
  formId?: string;
  className?: string;
}
export interface DispatchProps {
  refreshSchedule(tabId: string, formId?: string): void;
}
export type RefreshScheduleProps = StateProps & DispatchProps & RefreshSchedulePropsOwnProps;

export const mapStateToProps = (state: AppState, { tabId, formId }: RefreshSchedulePropsOwnProps): StateProps => {
  const isDisabled = isPendingEnrichment(state, tabId) || (isNonEmpty(formId) && isPendingEnrichment(state, formId));
  return {
    isDisabled,
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => {
  return {
    refreshSchedule(tabId, formId) {
      if (isDefined(formId)) {
        dispatch(refreshScheduleThunk(tabId, formId));
      } else {
        dispatch(refreshScheduleThunk(tabId, tabId));
      }
    },
  };
};

export const connectRefreshSchedule = connect(mapStateToProps, mapDispatchToProps);
